<template>
  <div>
    <v-card>
      <v-navigation-drawer
        style="margin-top:105px;z-index:110"        
        color=rgb(5,47,102,0.80)
        :expand-on-hover="components.nav_drawer.expand_on_hover"
        :mini-variant="components.nav_drawer.mini_variant"
        :right="components.nav_drawer.right"
        dark
        fixed
        width="600"
        height="500"
      >
        <ProductSelection v-if="components.nav_drawer.product_index==0"/>
        <MotorQuote  v-else-if="components.nav_drawer.product_index==1"/>
        <HouseOwnersQuote v-else-if="components.nav_drawer.product_index==2"/>
        <TravelQuote v-else-if="components.nav_drawer.product_index==3"/> 
        <GadgetsQuote v-else-if="components.nav_drawer.product_index==4"/> 
        <MuendeBwinoQuote v-else-if="components.nav_drawer.product_index==5"/> 
      </v-navigation-drawer>
    </v-card>
  </div>
</template>
<script>
  import ProductSelection from "@/components/ProductSelection.vue";
  import MotorQuote from "@/components/MotorQuote.vue";
  import HouseOwnersQuote from "@/components/HouseOwnersQuote.vue";
  import TravelQuote from "@/components/TravelQuote.vue";
  import GadgetsQuote from "@/components/GadgetsQuote.vue";
  import MuendeBwinoQuote from "@/components/MuendeBwinoQuote.vue";
  import { mapGetters } from "vuex";

  export default {
    name: "NavDrawer",
    components: {
      ProductSelection,
      MotorQuote,
      HouseOwnersQuote,
      TravelQuote,
      GadgetsQuote,
      MuendeBwinoQuote
    },
    data () {
      return {
        
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }
  }
</script>
